import App from './App';

import { createBrowserRouter } from 'react-router-dom'

import Login from './pages/login/login.js';
import BlocoNotas from './pages/notepad/notepad.js';
import ErrorPage from './pages/errorPage';
import Register from './pages/register/register.js';
import ResetPassword from './pages/resetPassword/resetPassword.js';
import Payments from './pages/payments/payments.js';



const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Login />
      },
      {
        path: "register",
        element: <Register />
      },
      {
        path: "reset-password/:token",
        element: <ResetPassword />
      },
      {
        path: "notepad",
        element: <BlocoNotas />
      },
      {
        path: "payments",
        element: <Payments />
      }
    ]
  }
])

export default router;